import * as moment from 'moment';
import Moment = moment.Moment;
import 'moment/locale/da';
import {User} from "@hassel-it/angular-common";
import {Shipment} from "./shipment";

export class ShipmentEvent {

    id?: string;
    shipment_status?: string;
    external_reference?: string;
    status_text: string;
    x?: number;
    y?: number;
    image?: string;
    date: Moment;
    image_links?: any;
    foreign_key?: string;
    model?: string;
    user?: User;
    shipment_status_formatted?: string;
    meta_data?: any;
    shipment?: Shipment;
    force?: boolean;
    is_notified?: boolean;
    _notify_driver?: boolean;

    static _JSONProps: string[] = [
        'id',
        'external_reference',
        'shipment_status',
        'status_text',
        'x',
        'y',
        'image',
        'image_links',
        'foreign_key',
        'model',
        'shipment_status_formatted',
        'meta_data',
        'is_notified'
    ];

    constructor(initializer?: ShipmentEventInterface) {
        if (initializer === undefined) {
            return;
        }
    }

    static fromJSON(json: ShipmentEventInterface | string): ShipmentEvent {
        if (json === null) {
            return new ShipmentEvent();
        }

        if (typeof json === 'string') {
            return JSON.parse(json, ShipmentEvent.reviver);
        } else {
            let task = Object.create(ShipmentEvent.prototype);

            let extra = {
                date: moment(json.date),
                user: null,
                shipment: null,
            };

            Object.keys(json).forEach((key, index) => {
                if (ShipmentEvent._JSONProps.indexOf(key) !== -1) {
                    task[key] = json[key];
                }

                if (key === 'user') {
                    extra.user = User.fromJSON(json[key]);
                }

                if (key === 'shipment' && json[key] !== null && json[key] !== undefined) {
                    extra.shipment = Shipment.fromJSON(json[key]);
                }
            });

            return Object.assign(task, extra);
        }
    }

    static reviver(key: string, value: any): any {
        return key === "" ? ShipmentEvent.fromJSON(value) : value;
    }

    public formattedDate?(field: string, format: string) {
        if (this[field]) {
            let thisField: Moment = this[field];
            if (thisField.isValid()) {
                return this[field].format(format);
            }
        }
    }
}

// A representation of Token data that can be converted to
// and from JSON without being altered.
export interface ShipmentEventInterface extends ShipmentEvent {
}
